import styled from "styled-components";
import { SLForm } from "~/pages/Sistema/componentes/SistemaList";
import { Colors } from "~/config/Colors";

export const Container = styled(SLForm)`
  width: 100%;
  max-width: 100%;

  .row {
    margin-bottom: 0.5em;
  }

  .no-padding {
    padding: 0 !important;
  }

  .no-margin {
    margin: 0 !important;
  }

  .header {
    padding: 0 0.6em;
    margin-bottom: 1em;
    display: flex;

    .item-aba {
      border-radius: 0.5em;
      padding: 0.3em 0.8em 0.3em 0.5em;
      background: ${Colors.Color2};
      margin-right: 0.6em;
      cursor: pointer;
      display: flex;
      flex-direction: row;
      align-items: center;

      span {
        content: "";
        display: block;
        width: 0.8em;
        height: 0.8em;
        background: ${Colors.Color4};
        margin-right: 0.5em;
        margin-left: 0.2em;
        border-radius: 0.15em;
      }

      p {
        font-size: 0.8125em;
        font-weight: 800;
        color: ${Colors.Color7};
      }
    }
    
    .item-aba.ativo {
      background: ${Colors.Color4} !important;

      span {
        background: ${Colors.Color9} !important;
      }

      p {
        color: ${Colors.Color9} !important;
      }
    }

    .h-descricao {
      font-size: 0.7125em;
      line-height: 0.8em;
      color: ${Colors.Color7};
    }
  }

  .item-modal {
    display: none;
  }
  
  .item-modal.ativo {
    width: 100%;
    height: 100%;
    display: block;
  }

  .footer {
    position: fixed;
    bottom: 1em;
    left: 1em;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`;

export const ThisCardItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${(props) => props?.cabecalho ? "1em" : "0.5em"};
  background: ${(props) => props?.cabecalho ? Colors.Color4 : localStorage.getItem("tema") == "E" ? Colors.Color27 : Colors.Color2};
  min-height: 2.6em;
  padding: 0.5em 1em;
  border-radius: 0.7em;

  .col {

    p {
      font-size: 0.8em;
      font-weight: 700;
      color: ${(props) => props?.cabecalho ? Colors?.Color9 : Colors?.Color14};
      margin-left: 0.5em;
    }

    .content-progress {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: flex-start;
    }

    .card-content {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
      width: 100%;

      .titulo {
        font-size: 0.7em;
        font-weight: bold;
        color: ${Colors.Color14};
        margin-left: 0.5em;
      }

      .progress {
        width: 75%;
        margin-left: 0.5em;
        border-radius: 1em;
        background: ${localStorage.getItem("tema") == "E" ? "#1D1D1D" : "#FFFFFF"};
        height: 1em;
      }
    }
  }

  .center {
    text-align: center;
  }

  .col1 {
    width: 5em;
  }

  .col2 {
    width: 10em;
  }

  .col2-2 {
    width: 12em;
  }

  .col3 {
    width: 15em;
  }

  .col3-2 {
    width: 17em;
  }

  .col4 {
    width: 20em;
  }

  .col4-2 {
    width: 22em;
  }

  .col5 {
    width: 25em;
  }
`;
